<!------------------------------------------------------------------------------
  - Copyright (c) 2019. BMW Group. All rights reserved.
  ----------------------------------------------------------------------------->


<app-generic-modal (primaryActionEvent)="save()"
                   [primaryActionEnabled]="isValid"
                   [primaryActionTitle]="primaryActionTitle"
                   [title]="title"
                   secondaryActionTitle="Discard">
    <div class="business-modal-body">
        <app-input-text #name
                        (inputValueChange)="nameInputChange($event)"
                        [messages]="nameMessages"
                        [validators]="validators.name"
                        [warningLevel]="WarningsEnum.WARNING_SAVE"
                        baseCypressTag="business-settings-transport-mode-modal-name"
                        label="Transport mode name"
                        maxLength="100"
                        placeholder="Please, write a transport mode name"></app-input-text>
        <app-input-text #code
                        (inputValueChange)="codeInputChange($event)"
                        [messages]="codeMessages"
                        [validators]="validators.code"
                        [warningLevel]="WarningsEnum.WARNING_SAVE"
                        baseCypressTag="business-settings-transport-mode-modal-code"
                        label="Transport mode code"
                        maxLength="2"
                        placeholder="Please, write a transport code, e.g. 86"></app-input-text>
        <app-input-dropdown #transportDocumentType
                            class="business-settings-transport-mode-modal-document-type"
                            [inputFormatter]="typeahead.inputTextNameFormatter"
                            [resultFormatter]="typeahead.inputTextNameFormatter"
                            [resultsFunction]="searchTransportDocumentTypes"
                            (inputValueChange)="transportDocumentTypeInputChange($event)"
                            [messages]="transportDocumentTypeMessages"
                            baseCypressTag="business-settings-transport-mode-modal-document-type"
                            label="Transport document type"
                            placeholder="Please, select a document type"></app-input-dropdown>

        <app-active-input [entityName]="ENTITY_NAME" [state]="$safeNavigationMigration(state?.isActive)"
                          (checkState)="setActiveInputState($event)"></app-active-input>
    </div>
</app-generic-modal>
